import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ServiceBase } from './service.base';

@Injectable()
export class NvgShapefileService extends ServiceBase {
  constructor(public http: HttpClient) {
    super();
  }

  getShapefilePressignedURL(nvgName, cropName, eventName) {
    const encodedNvgName = encodeURIComponent(nvgName);
    const encodedCropName = encodeURIComponent(cropName);
    const encodedEventName = encodeURIComponent(eventName);
    return this.http
      .get(
        `${this.UrlServiceV1}shapefile-service?id=${encodedNvgName}&event_name=${encodedEventName}&crop_name=${encodedCropName}`,
        { ...this.obterAuthHeader(), responseType: 'text' },
      )
      .pipe(map(this.extractData<string>), catchError(this.serviceError));
  }
}
